import types from './types';
// state object
export default {
  [types.STATE.DOSIER_ENTITY]: null,
  [types.STATE.DOSIER_FORMS]: null,
  [types.STATE.DOSIER_FRESH]: true
};
